import type { CancelToken } from 'axios';
import axios from 'axios';
import type { ParsedAppointment, ListingWithReps } from '@bb/domain/dist/types';

const getAppointment = async (
  appointmentId: string,
  cancelToken?: CancelToken,
) => {
  const {
    data: { appointment, listing },
  } = await axios.get<{
    appointment: ParsedAppointment;
    listing: ListingWithReps;
  }>(`/appointments/${appointmentId}`, {
    cancelToken,
  });

  return { appointment, listing };
};

export default getAppointment;
